import { Auth } from "aws-amplify"
import React, { useCallback, useEffect, useState } from "react"
import PhoneInput from "react-phone-number-input"
import "react-phone-number-input/style.css"
import { connect } from "react-redux"
import ReactSelect from "react-select"
import { useRouter } from "next/router"
import * as styles from "./SupplierSignupEnquiry.module.scss"
import { eventGtag } from "@lib/gtag"
import trackFBEvent from "@lib/trackFBEvent"
import fetchLambda from "@data/fetchLambda"
import lambdas from "@data/lambdas"
import { userGroupOptions } from "@data/static"
import * as actions from "@store/actions"
import Button from "@components/objects/Button/Button"
import ReactSelectAlias from "@components/objects/ReactSelectAlias/ReactSelectAlias"
import closeRed from "@images/icons/closeRed.svg"
import tickPink from "@images/icons/tickPink.svg"

const { SEND_EMAIL, MAILCHIMP_REQUEST, COGNITO_REQUEST, DATO_REQUEST } = lambdas[process.env.NEXT_PUBLIC_ENV]
const NEXT_PUBLIC_DOMAIN = process.env.NEXT_PUBLIC_DOMAIN
const NEXT_PUBLIC_ADMIN_EMAIL = process.env.NEXT_PUBLIC_ADMIN_EMAIL

const EnquiryForm = ({ authCheck, login, stage, staticData, userAttributes, referralId }) => {
  const router = useRouter()

  const { serviceOptions } = staticData
  const [inputs, setInputs] = useState({
    code: referralId ? referralId : "",
    fname: userAttributes.given_name ? userAttributes.given_name : "",
    lname: userAttributes.family_name ? userAttributes.family_name : "",
    email: userAttributes.email ? userAttributes.email : "",
    website: "",
    phone: "",
    supplierName: "",
    acquisition: "",
    password: "",
    passwordConfirm: "",
  })
  const [referral, setReferral] = useState({ id: "", message: "" })
  const [loading, setLoading] = useState(false)

  // useEffect(() => {
  //   setInputs({
  //     fname: userAttributes.given_name ? userAttributes.given_name : "",
  //     lname: userAttributes.family_name ? userAttributes.family_name : "",
  //     email: userAttributes.email ? userAttributes.email : "",
  //   })
  // }, [userAttributes])

  const handleChange = useCallback((event) => {
    const { name, value } = event.target
    setInputs((inputs) => ({
      ...inputs,
      [name]: value,
    }))
    if (name === "code") {
      getReferral(value)
    }
  })

  useEffect(() => {
    if (referralId) {
      getReferral(referralId)
    }
  }, [])

  const handleChangePhone = (value) => {
    setInputs((inputs) => ({
      ...inputs,
      phone: value,
    }))
  }

  // react select
  const handleChangeSelect = (selected, type) => {
    let value
    let name

    if (Array.isArray(selected)) {
      value = selected.map((selected) => selected.value)
      name = type.name
    } else {
      value = selected ? selected.value : []
      name = type.name
    }

    setInputs((inputs) => ({
      ...inputs,
      [name]: value,
    }))
  }

  const checkCode = (code) => {
    // returns next stage
    switch (code) {
      case "HOPPAPPROVED":
        return "payment"

      case "HOPPVENUE":
        return "form"

      default:
        return "enquired"
    }
  }

  const getReferral = async (value) => {
    if (!isNaN(value) && value.length >= 6) {
      const userSession = await Auth.currentSession()
      const result = await fetchLambda(DATO_REQUEST, {
        session: userSession.getIdToken().getJwtToken(),
        action: "get",
        itemId: value,
      })
      const supplier = result.data

      if (supplier?.name) {
        setReferral({
          id: value,
          message: supplier.name,
        })
      } else {
        setReferral({
          id: 404,
          message: "Supplier Not found",
        })
      }
    } else {
      setReferral({
        id: "",
        message: "",
      })
    }
  }

  // const generateCode = input => {
  //   let letters = input.replace(/[^a-z]/gi, "")
  //   if (!letters.length || letters.length < 5) {
  //     letters = (Math.random() + 1).toString(36).substring(6)
  //   }
  //   letters = letters.slice(0, 5).toUpperCase()
  //   const nums = Math.round(Math.random() * 10000)
  //   return `${letters}${nums}`
  // }

  const handleSubmit = async (event) => {
    event.preventDefault()

    if (stage === "new" && inputs.passwordConfirm !== inputs.password) {
      alert("Passwords do not match. Please try again")
      return
    }

    setLoading(true)
    try {
      // code setup
      const nextStage = checkCode(inputs.code)

      // get select labels
      const service = serviceOptions.find((el) => el.value === inputs.supplierservices)

      // setup new cognito attributes
      const attributes = {
        given_name: inputs.fname,
        family_name: inputs.lname,
        phone_number: inputs.phone, // e.164 format
        website: inputs.website,
        "custom:company_name": inputs.supplierName,
        "custom:acquisition": inputs.acquisition,
        "custom:status": nextStage,
        "custom:service": service.label,
        "custom:code": inputs.code ? inputs.code : "",
        "custom:referral": referral.id !== 404 ? referral.id : "",
      }

      // signup or update attributes in cognito
      let user
      if (stage === "existing") {
        user = await Auth.currentAuthenticatedUser()
        const resultUpdateAttr = await Auth.updateUserAttributes(user, attributes)
        if (resultUpdateAttr) {
          await authCheck()
        }
      } else if (stage === "new") {
        user = await Auth.signUp({
          username: inputs.email,
          password: inputs.password,
          attributes: {
            ...attributes,
            given_name: inputs.fname,
            family_name: inputs.lname,
            email: inputs.email,
          },
        })
      }

      // set username ID
      const userID = stage === "new" ? user.userSub : user.username

      if (nextStage === "enquired") {
        // send email to admin
        const resultEmail = await fetchLambda(SEND_EMAIL, {
          data: {
            toEmail: NEXT_PUBLIC_ADMIN_EMAIL,
            emailTemplate: "hoppSupplierSignupEnquiryTemplate",
            templateData: {
              link: `${NEXT_PUBLIC_DOMAIN}/admin/?u=${userID}`,
              givenName: inputs.fname ? inputs.fname : "-",
              familyName: inputs.lname ? inputs.lname : "-",
              email: inputs.email ? inputs.email : "-",
              phoneNumber: inputs.phone ? inputs.phone : "-",
              website: inputs.website ? inputs.website : "-",
              companyName: inputs.supplierName ? inputs.supplierName : "-",
              service: service.label ? service.label : "-",
              acquisition: inputs.acquisition ? inputs.acquisition : "-",
            },
          },
        })
      }

      // add or update mailchimp
      const responseMailchimp = await fetchLambda(MAILCHIMP_REQUEST, {
        data: {
          email: inputs.email,
          mergeFields: {
            FNAME: inputs.fname,
            LNAME: inputs.lname,
            STAGE: nextStage,
          },
          tags: "Supplier",
        },
      })

      // ga analytics
      eventGtag({
        action: "enquired",
        params: {
          event_category: service?.label ? service.label : "SupplierForm",
          event_label: inputs.supplierName,
          value: inputs.email,
        },
      })

      if (stage === "new") {
        await login(inputs.email, inputs.password)
      }

      // fb analytics
      trackFBEvent("Lead", {
        user_email: inputs.email,
        content_category: service?.label ? service.label : "SupplierForm",
      })

      // update user group
      const userSession = await Auth.currentSession()
      const sessionToken = userSession.getIdToken().getJwtToken()
      const nextGroup = userGroupOptions.group.find((el) => el.label.toLowerCase() === nextStage)
      await fetchLambda(COGNITO_REQUEST, {
        session: sessionToken,
        username: userID,
        action: "add",
        group: nextGroup ? nextGroup.value : "SupplierEnquired",
      })

      // go to signup
      router.push("/supplier-signup")
    } catch (e) {
      alert(e.message)
      setLoading(false)
    }
  }

  const passwords = (
    <>
      <div>
        <label>
          Password*
          <br />
          - Min 8 characters
          <br />- Min one lowercase, one uppercase letter, one number
        </label>
        <input required value={inputs.password} onChange={handleChange} type="password" name="password" />
      </div>
      <div>
        <label>Confirm Password*</label>
        <input required value={inputs.passwordConfirm} onChange={handleChange} type="password" name="passwordConfirm" />
      </div>
    </>
  )

  // react select style overide
  const reactSelectStyles = {
    control: (base, state) => ({
      ...base,
      boxShadow: state.isFocused ? "0 0 0 1px #ccc" : 0,
    }),
    multiValueRemove: (styles) => ({
      ...styles,
      color: "#fd78de",
      ":hover": {
        backgroundColor: "#fd78de",
        color: "white",
      },
    }),
  }

  const acquisitionOptions = [
    { label: "Facebook", value: "Facebook" },
    { label: "Instagram ", value: "Instagram" },
    { label: "Google", value: "Google" },
    { label: "Referral", value: "Referral" },
  ]

  return (
    <form onSubmit={handleSubmit}>
      <div>
        <label>First Name*</label>
        <input type="text" name="fname" value={inputs.fname} onChange={handleChange} required />
      </div>
      <div>
        <label>Last Name*</label>
        <input type="text" name="lname" value={inputs.lname} onChange={handleChange} required />
      </div>

      <div>
        <label>Phone*</label>
        <PhoneInput
          required
          placeholder="Enter phone number"
          defaultCountry="GB"
          value={inputs.phone}
          onChange={handleChangePhone}
        />
      </div>
      <div>
        <label>Email*</label>
        <input
          type="email"
          name="email"
          value={inputs.email}
          onChange={handleChange}
          disabled={stage === "existing"}
          required
        />
      </div>

      <div className={styles.select}>
        <label>Service*</label>
        <ReactSelect
          styles={reactSelectStyles}
          classNamePrefix="react-select"
          className="react-select-container"
          id="supplierservices"
          instanceId="supplierservices"
          name="supplierservices"
          onChange={handleChangeSelect}
          options={serviceOptions}
          value={serviceOptions.filter((v) => inputs.supplierservices === v.value)}
        />
        <ReactSelectAlias value={inputs.supplierservices} />
      </div>
      <div>
        <label>Company Name*</label>
        <input type="text" name="supplierName" value={inputs.supplierName} onChange={handleChange} required />
      </div>

      <div className={styles.select}>
        <label>How did you find us?*</label>
        <ReactSelect
          styles={reactSelectStyles}
          classNamePrefix="react-select"
          className="react-select-container"
          id="acquisition"
          instanceId="acquisition"
          name="acquisition"
          onChange={handleChangeSelect}
          required
          options={acquisitionOptions}
          value={acquisitionOptions.filter((v) => inputs.acquisition === v.value)}
        />
        <ReactSelectAlias value={inputs.acquisition} />
      </div>
      <div>
        <label>Website*</label>
        <input type="text" name="website" value={inputs.website} onChange={handleChange} required />
      </div>
      {stage === "new" && passwords}
      <div className={styles.full}>
        <label>Have a code, please enter</label>
        <div className={`${styles.code} ${referral.id && referral.id !== 404 ? styles.found : ""}`}>
          <input type="text" name="code" value={inputs.code} onChange={handleChange} />
          {referral.id ? (
            <span>
              <img src={referral.id === 404 ? closeRed : tickPink} alt="" />
              {referral.message}
            </span>
          ) : null}
        </div>
      </div>

      <Button className={styles.submit} text="Send" type="submit" disabled={loading} />
    </form>
  )
}

const mapDispatchToProps = (dispatch) => ({
  authCheck: async () => await dispatch(actions.authCheck()),
  login: async (email, password) => await dispatch(actions.login(email, password)),
})

const mapStateToProps = (state) => ({
  staticData: state.staticData.data,
  isAuthenticated: state.auth.isAuthenticated,
})

export default connect(mapStateToProps, mapDispatchToProps)(EnquiryForm)
